import {QueryCommand} from "xmgoing-server";
import {usePageModelsStore} from "@/store/modules/pageModels";

/**
 * 简易流程单据类型统一配置：按 tableCode 维护
 * - recordIdStateKey：业务记录 id 写入页面模型全局状态的 key（页面配置绑定取值）
 * - submitUrl：审批提交接口地址（未配置时走默认 /lccSimpleFlowInstance/submitByBusId）
 * 审批接口优先级：getCurrentNode 节点配置（submitMethod/backMethod/bizSaveMethod）
 *   > 本表 tableCode 映射 > 默认简易流程接口
 * 新增单据类型时在此登记，记录 id 回填与提交审批逻辑自动生效
 */
export const SIMPLE_FLOW_TABLE_CONFIGS: Record<string, {
  recordIdStateKey?: string;
  submitUrl?: string;
  formKey?: string;
  pageCode?: string;
  moduleCode?: string;
}> = {
  // // 吊装单
  // "TB_DIRECT_TRANSFER": {
  //   recordIdStateKey: "curRecordId",
  //   submitUrl: "/api/xm-mes/directTransfer/base/audit",
  //   formKey:'copycecbpnonsslgedsscdnissiafgsskbbn',
  //   pageCode:'japnfjngssjdidsscank97518dc69f3d6d06a06223b8bca4ae73e3e7',
  // },
  // 借用单
  // "TB_000000_1840687902593445889_SALESORDER": {
  //   submitUrl: "/api/xm-mes/borrow/base/audit",
  //   formKey:'copyngdNHH',
  //   pageCode:'japnfjngssjdidsscank97518dc69f3d6d06a06223b8bca4aef43f7a',
  // },
  // 组装单
  // "TB_DISASSEMBLE": {
  //   recordIdStateKey: "curReocrdId",
  //   submitUrl: "/api/xm-mes/disassemble/base/audit",
  //   formKey:'copycecbpnonsslgedsscdnissiafgsskbbn',
  //   pageCode:'behlglapssjeiasscbbncd523b',
  // },
  //委外收料单
  "MES_OUTSOURCING_MATERIAL_RECEIPT": {
    recordIdStateKey: "curOutSourcingReceiveId",
    submitUrl: "/api/xm-mes/outsourcingMaterialReceipt/base/audit",
    formKey:'copypmkjpjkfsshbgjsscobcssidbbssiilk',
    pageCode:'outsourcingReceiveDetail',
    moduleCode:'355377534482776133',
  },
  //委外发料单
  "MES_OUTSOURCING_OUT_STOCK": {
    recordIdStateKey: "curOutSourcingStockId",
    submitUrl: "/api/xm-mes/outsourcingOutStock/base/audit",
  },
  //委外转移单
  "MES_OUTSOURCING_TRANSFER": {
    recordIdStateKey: "curOutSourcingTransferId",
    submitUrl: "/api/xm-mes/outsourcingTransfer/base/audit",
    formKey:'copymbiafkblsscklnsscfgcssihpmsselhp',
    pageCode:'outsourcingTransferDetail',
    moduleCode:'430986205400662085',
  },
  //委外订单
  "TB_OUTSOURCING_ORDER": {
    recordIdStateKey: "curOutSourcingOrderId",
    submitUrl: "/api/xm-mes/outsourcingOrder/base/audit",
  },
  //委外申请
  "TB_OUTSOURCING_APPLICATION": {
    recordIdStateKey: "curOutSourcingApplyId",
    submitUrl: "/api/xm-mes/outsourcingApplication/base/audit",
  },
  //生产退料
  "TB_PRO_RETURN_ORDER": {
    recordIdStateKey: "curReocrdId",
    submitUrl: "/api/xm-mes/proReturnOrder/base/audit",
    formKey:'copydjeljhobssaemksscepassipbossoaed',
    pageCode:'japnfjngssjdidsscank97518dc69f3d6d06a00124596ccb8444c245ab62ef815775',
  },
  // 备件退回
  "MES_OTHER_IN_ORDER": {
    recordIdStateKey: "curReocrdId",
    submitUrl: "/api/xm-mes/otherInOrder/base/audit",
    formKey:'copyhecmnnilssanoisscngossijghssgpng',
    pageCode:'phlgenlassclojsschlk92f3a2',
  },
  // 备件领用
  "MES_OTHER_OUT_ORDER": {
    recordIdStateKey: "curReocrdId",
    submitUrl: "/api/xm-mes/otherOutOrder/base/audit",
    formKey:'ookabhjgssbkalsschalssijimsspmlg',
    pageCode:'cfodnogkssgepnsscpll019ca3',
  },
  // 送检计划
  "TB_SUBMISSION_PLAN": {
    recordIdStateKey: "curReocrdId",
    submitUrl: "/api/xm-mes/submissionPlan/base/audit",
    formKey:'copycecbpnonsslgedsscdnissiafgsskbbn',
    pageCode:'japnfjngssjdidsscank97518dc69f3d6d06a00516e94dd621dd4e27ba0dc2',
  },
  // 保养计划
  "TB_MAINTENANCE_PLAN": {
    recordIdStateKey: "curReocrdId",
    submitUrl: "/api/xm-mes/maintenancePlan/base/audit",
    formKey:'copycecbpnonsslgedsscdnissiafgsskbbn',
    pageCode:'japnfjngssjdidsscank97518dc69f3d6d06a00516e94dd621dd4e27',
  },
  // 设备点检计划
  "TB_CHECK_POINTPLAN": {
    recordIdStateKey: "curReocrdId",
    submitUrl: "/api/xm-mes/checkPointplan/base/audit",
    formKey:'copymbegbedhsshblnsscjnjssihoasshjkk',
    pageCode:'oilhhlkjssndhdssccje',
  },
  // 设备异常
  "TB_DEVICE_ABNORMAL": {
    recordIdStateKey: "curReocrdId",
    submitUrl: "/api/go-lcc/execute/base/audit/TB_DEVICE_ABNORMAL",
    formKey:'copycecbpnonsslgedsscdnissiafgsskbbn',
    pageCode:'japnfjngssjdidsscank97518dc69f3d6d06a00516e9',
  },
  // 日常点检
  "TB_DAILY_CHECK": {
    recordIdStateKey: "curReocrdId",
    submitUrl: "/api/go-lcc/execute/base/audit/TB_DAILY_CHECK",
    formKey:'newegpaiedpssgegpsscjmessin',
    pageCode:'moemmbdfsspndnssciji',
  },
  // 其他设备工单
  "TB_OTHER_EQUIPMENT_WORKORDER": {
    recordIdStateKey: "curReocrdId",
    submitUrl: "/api/xm-mes/otherEquipmentWorkorder/base/audit",
    formKey:'copycdnbamgjssanlgsschemssiddossgjkk',
    pageCode:'japnfjngssjdidsscank97518dc69f3d6d06a00516e94dd6211b1179fd58af',
  },
  // 保养工单
  "TB_MAINTENANCE": {
    recordIdStateKey: "curReocrdId",
    submitUrl: "/api/xm-mes/maintenance/base/audit",
    formKey:'copycecbpnonsslgedsscdnissiafgsskbbn',
    pageCode:'japnfjngssjdidsscank97518dc69f3d6d06a00516e94dd6215180a8',
  },
  // 巡检
  "TB_PATROLINSPECTION": {
    recordIdStateKey: "curReocrdId",
    submitUrl: "/api/xm-mes/patrolinspectionOrder/base/audit",
    formKey:'copycdnbamgjssanlgsschemssiddossgjkk',
    pageCode:'japnfjngssjdidsscank97518dc69f3d6d06a00516e94dd6211b1179',
  },
  // 维修工单
  "TB_WEIXIU_TASKLIST": {
    recordIdStateKey: "curReocrdId",
    submitUrl: "/api/xm-mes/repairWorkorder/base/audit",
  },
  // 设备验收单
  "MES_EQUIPMENT_ACCEPTANCE": {
    recordIdStateKey: "curReocrdId",
    submitUrl: "/api/xm-mes/mesEquipmentAcceptance/base/audit",
    formKey:'copycecbpnonsslgedsscdnissiafgsskbbn',
    pageCode:'japnfjngssjdidsscank97518dc69f3d6d06a00516e94dd621840e56',
  },
  // 部件领用单
  "MES_MOLD_COMPONENTS_USE": {
    recordIdStateKey: "curMoldUseId",
    submitUrl: "/api/xm-mes/moldComponentsUse/base/audit",
  },
  // 模具领用单
  "MES_MOLD_USE": {
    recordIdStateKey: "curMoldUseId",
    submitUrl: "/api/xm-mes/moldUse/base/audit",
  },
  // 部件采购单
  "MES_MOLD_COMPONENT_PURCHASE": {
    recordIdStateKey: "curRecordId",
    submitUrl: "/api/xm-mes/moldComponentPurchase/base/audit",
  },
  // 模具报废单
  "MES_MOLD_SCRAP_ORDER": {
    recordIdStateKey: "curRecordId",
    submitUrl: "/api/xm-mes/scrapOrder/base/audit",
  },
  // 模具采购单
  "MES_MOLD_PURCHASE": {
    recordIdStateKey: "curRecordId",
    submitUrl: "/api/xm-mes/moldPurchase/base/audit",
  },
  // 模具维修工单
  "MES_MOLD_REPAIR_WORK_ORDER": {
    recordIdStateKey: "curRecordId",
    submitUrl: "/api/xm-mes/moldRepairWorkOrder/base/audit",
    formKey:'copycecbpnonsslgedsscdnissiafgsskbbn',
    pageCode:'bjckcpnpssignksscknb',
  },
  // 模具保养工单
  "MES_MOLD_MAINTENANCE_ORDER": {
    recordIdStateKey: "curRecordId",
    submitUrl: "/api/xm-mes/moldMaintenancePlan/base/audit",
    formKey:'copyicmknbmesslgmgsscmcmssijhjssddmk',
    pageCode:'japnfjngssjdidsscank97518dc69f3d6d06a00516e94dd6215180a8f44117',
  },
  // 模具保养计划
  "MES_MOLD_MAINTENANCE_PLAN": {
    recordIdStateKey: "curRecordId",
    submitUrl: "/api/xm-mes/moldMaintenancePlan/base/audit",
    formKey:'copyiohombppssglopsscpmdssimgessmhbf',
    pageCode:'japnfjngssjdidsscank97518dc69f3d6d06a00516e94dd621dd4e27e054fe',
  },
  // 盘亏单
  "TB_SHORTAGE_ORDER": {
    recordIdStateKey: "curReocrdId",
    submitUrl: "/api/xm-mes/shortageOrder/base/audit",
    formKey:'newiccnncphssjpmhssccmgssie',
    pageCode:'mkhjkpdhsspofhsscdii',
  },
  // 盘盈单
  "TB_OVERSTOCK_SHEET": {
    recordIdStateKey: "curReocrdId",
    submitUrl: "/api/xm-mes/overstockSheet/base/audit",
    formKey:'copyjldllkpisskkfhsschppssiccassgjem',
    pageCode:'gopfahinssfkiesschnb',
  },
  // 盘点表
  "TB_INVENTORY_TASK": {
    recordIdStateKey: "curReocrdId",
    submitUrl: "/api/xm-mes/inventoryTask/base/audit",
    formKey:'newmcflljhisshaacsscncessib',
    pageCode:'ohoiponossbcbessccma',
  },
  // 组装单
  "TB_DISASSEMBLE": {
    recordIdStateKey: "curReocrdId",
    submitUrl: "/api/xm-mes/disassemble/base/audit",
    formKey:'copycecbpnonsslgedsscdnissiafgsskbbn',
    pageCode:'behlglapssjeiasscbbn',
  },
  // 跨组织调拨
  "TB_CROSS_ORG_ALLOCATION": {
    submitUrl: "/api/xm-mes/tenantDirectTransfer/base/audit",
    formKey:'copycecbpnonsslgedsscdnissiafgsskbbn',
    pageCode:'japnfjngssjdidsscank97518dc69f3d6d06a06223b8bca4ae9580fc',
  },
  // 调拨单
  "TB_DIRECT_TRANSFER": {
    recordIdStateKey: "curRecordId",
    submitUrl: "/api/xm-mes/directTransfer/base/audit",
    formKey:'copycecbpnonsslgedsscdnissiafgsskbbn',
    pageCode:'japnfjngssjdidsscank97518dc69f3d6d06a06223b8bca4ae',
  },
  "MES_OTHER_IN_ORDER": {
    recordIdStateKey: "curRecordId",
    submitUrl: "/api/xm-mes/otherInOrder/base/audit"
  },
  "MES_OTHER_OUT_ORDER": {
    submitUrl: "/api/xm-mes/otherOutOrder/base/audit"
  },
  "MES_OUT_STOCK_APPL": {
    recordIdStateKey: "curReocrdId",
    submitUrl: "/api/xm-mes/outStockApplication/base/audit"
  },
  "TB_000000_1840687902593445889_SALESORDER": {
    recordIdStateKey: "curSaleOrderId",
    submitUrl: "/api/xm-mes/salesOrder/base/audit"
  },
  "TB_SALES_RETURNORDER": {
    recordIdStateKey: "curSaleReturnId",
    submitUrl: "/api/xm-mes/salesReturnOrder/base/audit"
  },
  "TB_SALES_PLAN": {
    recordIdStateKey: "curSalePlanId",
    submitUrl: "/api/xm-mes/salesPlan/base/audit"
  },
  "TB_SALESCHANGEORDER": {
    recordIdStateKey: "curRecordId",
    submitUrl: "/api/xm-mes/salesChangeOrder/base/audit"
  },
  "MES_DELIVERY_NOTICE": {
    recordIdStateKey: "curDeliveryNoticeId",
    submitUrl: "/api/xm-mes/deliveryNotice/base/audit"
  },
  "MES_SALES_OUT_ORDER": {
    recordIdStateKey: "curSaleOutId",
    submitUrl: "/api/xm-mes/salesOutOrder/base/audit"
  },
  "TB_SALES_RETURN_APPLICATION": {
    recordIdStateKey: "curSaleReturnApplyId",
    submitUrl: "/api/xm-mes/salesReturnApplication/base/audit"
  },
  "mes_purchas_request": {
    recordIdStateKey: "formDataId",
    submitUrl: "/api/xm-mes/purchasRequest/base/audit"
  },
  "MES_PURCHASE_ORDER": {
    recordIdStateKey: "curSaleReturnId",
    submitUrl: "/api/xm-mes/purchaseOrder/base/audit"
  },
  "MES_PURCHASE_ORDER_CHANGE": {
    recordIdStateKey: "curOrderId",
    submitUrl: "/api/xm-mes/purchaseOrderChange/base/audit"
  },
  "TB_MATERIAL_RECEIPT": {
    recordIdStateKey: "curReceiptNoticeId",
    submitUrl: "/api/xm-mes/materialReceipt/base/audit"
  },
  "MES_PURCHASE_STOCK_IN_BILL": {
    recordIdStateKey: "curPurchaseInventoryId",
    submitUrl: "/api/xm-mes/purchaseStockInBill/base/audit"
  },
  "MES_PURCHASE_MATERIAL_RETURN_APPLICATION": {
    recordIdStateKey: "curRecordId",
    submitUrl: "/api/xm-mes/purchaseMaterialReturnApplication/base/audit"
  },
  "MES_PURCHASE_RETURN_MATERIAL": {
    recordIdStateKey: "curPurchaseReturnId",
    submitUrl: "/api/xm-mes/purchaseReturnMaterial/base/audit"
  },
  "TB_RECEIPT_INFO": {recordIdStateKey: "curReceiveOrderId"},
  "TB_RECEIVABLE_BILL": {
    recordIdStateKey: "curEstimatedReceivablesId",
    submitUrl: "/api/xm-mes/receivableBill/base/audit"
  },
  "TB_FINANCIAL_RECEIVA_BLEBILL": {
    recordIdStateKey: "curFinancialReceivablesId",
    submitUrl: "/api/xm-mes/financialReceivaBlebill/base/audit"
  },
};

/**
 * 记录 id 写入页面模型全局状态：页面配置通过 recordIdStateKey 绑定的全局状态取值
 * @param id 业务记录 id
 * @param tableCode 单据实体编码（命中统一配置时同步写入映射的全局状态 key）
 */
export const applyRecordIdState = function (id: string, tableCode: string) {
  const pageModelsStore: any = usePageModelsStore();
  pageModelsStore.state['formDataId'] = id;
  pageModelsStore.state['rowData'] = {id};
  const config = SIMPLE_FLOW_TABLE_CONFIGS[tableCode];
  if (config && config.recordIdStateKey) {
    pageModelsStore.state[config.recordIdStateKey] = id;
  }
};

/**
 * 提交数据 并发起流程
 * @param params
 * @param backFun
 * 业务参数放在params的variables里面
 */
export const executeStartFlowFun = function (params, backFun) {
  const queryCommand = new QueryCommand({
    showTip: false,
    url: `/api/go-lcc/lccSimpleFlowInstance/startFlow`,
  });
  queryCommand.executeQueryPromise({params}).then((des) => {
    backFun && backFun(des);
  });
}
/**
 * 从 getCurrentNode 响应中取节点配置的审批接口地址
 * 优先读顶层字段，其次 configs（兼容节点 configs 未拍平的返回）
 * 表单提交设置显式关闭（submitEnabled=false）时忽略残留地址，回落默认接口
 */
export const pickNodeActionUrl = function (res: any, key: string): string {
  if (!res || isNodeSubmitDisabled(res)) {
    return '';
  }
  const raw = res[key] || (res.configs && res.configs[key]) || '';
  return normalizeFlowApiUrl(raw);
};

/**
 * 设计器「表单提交设置」开关：显式 false 时不用节点自定义接口
 * 未返回该字段时视为未关闭，仍按「有地址则优先」兼容旧节点数据
 */
const isNodeSubmitDisabled = function (res: any): boolean {
  if (res.submitEnabled === false) {
    return true;
  }
  return !!(res.configs && res.configs.submitEnabled === false);
};

/**
 * 规范化节点配置的接口地址：去空格；缺前导 / 时补上
 * 不自动补 /api 或 /api/go-lcc：无法区分 xm-mes / go-lcc，猜错会打到错误服务
 */
export const normalizeFlowApiUrl = function (url?: string): string {
  const u = typeof url === 'string' ? url.trim() : '';
  if (!u) {
    return '';
  }
  if (/^https?:\/\//i.test(u) || u.charAt(0) === '/') {
    return u;
  }
  return '/' + u;
};

const trimUrl = function (url?: string) {
  return normalizeFlowApiUrl(url);
};

/**
 * 修改操作
 * @param tableCode
 * @param params
 * @param backFun
 * @param errorFun 失败回调（保存失败时关闭 loading 等）
 * @param customUrl 节点配置的业务保存接口（bizSaveMethod），有值则优先使用
 */
export const updateDomainRecord = function (tableCode, params, backFun, errorFun?, customUrl?: string) {
  const queryCommand = new QueryCommand({
    showTip: false,
    url: trimUrl(customUrl) || `/api/go-lcc/execute/updateByTableCode/` + tableCode,
  });
  queryCommand.executeQueryPromise({params}).then((des) => {
    backFun && backFun(des);
  }).catch(() => {
    errorFun && errorFun();
  });
}

/**
 * 保存操作
 * @param tableCode
 * @param params
 * @param backFun
 * @param errorFun 失败回调（保存失败时关闭 loading 等）
 * @param customUrl 节点配置的业务保存接口（bizSaveMethod），有值则优先使用
 */
export const saveDomainRecord = function (tableCode, params, backFun, errorFun?, customUrl?: string) {
  const queryCommand = new QueryCommand({
    showTip: false,
    url: trimUrl(customUrl) || `/api/go-lcc/execute/saveByTableCode/` + tableCode,
  });
  queryCommand.executeQueryPromise({params}).then((des) => {
    backFun && backFun(des);
  }).catch(() => {
    errorFun && errorFun();
  });
}
/**
 * 执行提交操作
 * @param params
 * @param backFun
 */
export const executeSubmitFun = function ({params, backFun}) {
  const queryCommand = new QueryCommand({
    showTip: false,
    url: `/api/go-lcc/lccSimpleFlowInstance/submitByBusIds`,
  });
  queryCommand.executeQueryPromise({params}).then((des) => {
    if (des) {
      backFun && backFun(des);
    }
  });
}


/**
 * 根据业务记录 id 执行提交操作
 * 接口优先级：节点 submitMethod > SIMPLE_FLOW_TABLE_CONFIGS.submitUrl > 默认 submitByBusId
 * @param params
 * @param customUrl 节点配置的提交/审核接口（submitMethod），有值则优先使用
 */
export const submitByBusId = async function (params, customUrl?: string) {
  const nodeUrl = trimUrl(customUrl);
  if (nodeUrl) {
    return new QueryCommand({
      showTip: false,
      url: nodeUrl,
    }).executeQueryPromise({params});
  }
  if (!params.tableCode) {
    return;
  }
  // 如果存在映射提交路径 则取映射路径来执行
  const tableConfig = SIMPLE_FLOW_TABLE_CONFIGS[params.tableCode];
  if (tableConfig && tableConfig.submitUrl) {
    const queryCommand = new QueryCommand({
      showTip: false,
      url: tableConfig.submitUrl,
    });
    return queryCommand.executeQueryPromise({params});
  }
  const queryCommand = new QueryCommand({
    showTip: false,
    url: `/api/go-lcc/lccSimpleFlowInstance/submitByBusId`,
  });
  return queryCommand.executeQueryPromise({params});
}
/**
 * 提交发起流程记录
 * @param params
 */
export const startFlowByBusId = async function (params) {
  const queryCommand = new QueryCommand({
    showTip: false,
    url: `/api/go-lcc/lccSimpleFlowInstance/submitByBusId`,
  });
  return queryCommand.executeQueryPromise({params});
}
/**
 * 根据流程id进行退回操作
 * @param params
 * @param backFun
 */
export const executeBackByFlowIdFun = function ({params, backFun}) {
  const queryCommand = new QueryCommand({
    showTip: false,
    url: `/api/go-lcc/lccSimpleFlowInstance/backFlowByFlowIds`,
  });
  queryCommand.executeQueryPromise({params}).then((des) => {
    if (des) {
      backFun && backFun(des);
    }
  });
}
/**
 * 根据业务记录进行退回操作
 * @param params
 * @param backFun
 */
export const executeBackFunByBusId = function ({params, backFun}) {
  const queryCommand = new QueryCommand({
    showTip: false,
    url: `/api/go-lcc/lccSimpleFlowInstance/backFlowByBusId`,
  });
  queryCommand.executeQueryPromise({params}).then((des) => {
    if (des) {
      backFun && backFun();
    }
  });
}

/**
 * 根据流程id执行提交操作
 * @param params
 * @param backFun
 */
export const executeSubmitByFlowIdFun = function ({params, backFun}) {
  const queryCommand = new QueryCommand({
    showTip: false,
    url: `/api/go-lcc/lccSimpleFlowInstance/submitByFlowIds`,
  });
  queryCommand.executeQueryPromise({params}).then((des) => {
    if (des) {
      backFun && backFun(des);
    }
  });
}

/**
 * 批量提交（批量同意）：跨单据类型混合勾选的待办记录一次提交，无需按 tableCode 拆分
 * 接口：POST /api/go-lcc/lccSimpleFlowInstance/submitByFlowIds
 * @param params ids 流程实例 id 分号拼接、conclusion 审批结论（同意=批量提交，不同意后端自动转批量回退）、opinion 审批意见（可选）
 */
export const batchSubmitByFlowIds = function (params: {ids: string; conclusion: string; opinion?: string}) {
  return new QueryCommand({
    showTip: false,
    url: `/api/go-lcc/lccSimpleFlowInstance/submitByFlowIds`,
  }).executeQueryPromise({params, page: false});
}

/**
 * 查询流程日志（审批历史）
 * @param id 流程实例 id
 */
export const listApprovalHistory = function (id: string) {
  return new QueryCommand({
    showTip: false,
    url: `/api/go-lcc/lccSimpleFlowInstance/listHistory`,
    method: 'GET',
  }).executeQueryPromise({params: {current: 1, id}, page: false});
}

/**
 * 查询当前节点表单配置
 * @param id 流程实例 id
 */
export const getCurrentNodeConfig = function (id: string) {
  return new QueryCommand({
    showTip: false,
    url: `/api/go-lcc/lccSimpleFlowInstance/getCurrentNode`,
    method: 'GET',
  }).executeQueryPromise({params: {id}, page: false});
}

/**
 * 根据业务记录 id 执行单记录退回（结论=不同意）
 * 接口优先级：节点 backMethod > 默认 singleBackFlowByBusId
 * @param params 退回参数（id/opinion/conclusion）
 * @param customUrl 节点配置的回退接口（backMethod），有值则优先使用
 */
export const singleBackFlowByBusId = function (params: any, customUrl?: string) {
  return new QueryCommand({
    showTip: false,
    url: trimUrl(customUrl) || `/api/go-lcc/lccSimpleFlowInstance/singleBackFlowByBusId`,
  }).executeQueryPromise({params, page: false});
}
